module.exports = __webpack_public_path__ + "img/water_des_5.ef0cb12c.jpg";